import { Module, VuexModule, Mutation, Action } from 'vuex-module-decorators';
import { IMarkers } from '@/interfaces/data';
import axios from 'axios';
import { getAllApiResults } from '@/store/helpers/apiCallHelpers.ts';
import {
  COPY_MARKERS_TO_TEMPMARKERS,
  SET_TEMP_MARKERS,
  ADD_MARKER_TO_TEMPMARKERS,
  CLEAR_TEMPMARKERS
} from '@/store/constants/mutation-types';

@Module({ namespaced: true, name: 'LocationModule' })
export default class LocationModule extends VuexModule {
  private LOCATION_URL = `${process.env.VUE_APP_API_ENDPOINT}api/v1/location`;
  private PROJECT_URL = `${process.env.VUE_APP_API_ENDPOINT}api/v1/project`;
  private CUSTOMER_URL = `${process.env.VUE_APP_API_ENDPOINT}api/v1/customer`;
  private markers = [];
  private tempMarkers = [];

  @Mutation
  private [CLEAR_TEMPMARKERS]() {
    this.tempMarkers = [];
  }

  @Mutation
  private [SET_TEMP_MARKERS](markers) {
    this.tempMarkers = [];
    this.tempMarkers = markers;
    console.log(this.tempMarkers);
  }

  @Mutation
  private [ADD_MARKER_TO_TEMPMARKERS](marker) {
    this.tempMarkers.push(marker);
  }

  @Mutation
  private removeMarkerFromtempMarkers(projectId) {
    this.tempMarkers = this.tempMarkers.filter(
      location => location.projectId !== projectId
    );
  }

  @Mutation
  private [COPY_MARKERS_TO_TEMPMARKERS]() {
    this.tempMarkers = [];
    this.tempMarkers = this.markers;
  }

  @Mutation
  private setLocation(locations) {
    locations.map(location => {
      const coverage =
        location.sigfox_coverage_desc !== 'No Coverage' &&
        location.sigfox_coverage_desc !== null;

      this.markers.push({
        position: { lat: location.latitude, lng: location.longitude },
        projectId: location.project_id,
        coverage,
        coverageStatus: location.sigfox_coverage,
        margins: location.sigfox_margins
          ? location.sigfox_margins.split(',').map(item => Number(item))
          : [0, 0, 0]
      });
    });
  }

  @Mutation
  private clearAllMarkers() {
    this.tempMarkers = [];
    this.markers = [];
  }

  @Mutation
  private deleteLocation(projectId) {
    this.markers = this.markers.filter(
      location => location.projectId !== projectId
    );
    this.tempMarkers = this.markers;
    console.log(this.tempMarkers);
  }

  @Action({ rawError: true })
  private async requestAllLocationsForProject({ token, projectId }) {
    return new Promise((resolve, reject) => {
      getAllApiResults(
        `${this.PROJECT_URL}/${projectId}/locations?per_page=1000000`,
        [],
        token,
        resolve,
        reject
      );
    })
      .then(response => {
        this.setLocation(response);
      })
      .catch(error => console.log(error));
  }

  @Action({ rawError: true })
  private async requestAllLocationsForCustomer({ token, customerId }) {
    return new Promise((resolve, reject) => {
      getAllApiResults(
        `${this.CUSTOMER_URL}/${customerId}/locations?per_page=1000000`,
        [],
        token,
        resolve,
        reject
      );
    })
      .then(response => {
        this.setLocation(response);
      })
      .catch(error => console.log(error));
  }
}
